// extracted by mini-css-extract-plugin
module.exports = {"compContainer":"inputBox__compContainer___MqkCW","comp":"inputBox__comp___RnbBg"};